import React, { useEffect, useState } from "react";
import { Row, Col ,Table, Image } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { usePrevious } from "./usePrevius";
import {FormatTwoDecimals, FormatThreeDecimals, XrpFormatMoney} from "./helpers/formatMoney"
import Backend from "../../../Backend";
import Connection from '../../../Calls';
import FormatMoney from "../../../Helpers/formatMoney";
import ListCoins  from "../ListCoins";
import UsdIcon from '../../../CryptoIcons/usd.svg';
import MxnIcon from '../../../CryptoIcons/mxn.svg';
import './WalletsComponent.css';

const WalletIndex = (props) => {
  const [coinsInfo, setCoinsInfo] = useState([]);
  const [balance, setBalance] = useState({
    balance_virtual: 0,
    balance_virtual_mxn: 0
  })
  const prevCalculation = usePrevious(props.prices || {});
  useEffect(()=> {
  }, [])

  useEffect(()=> {
    getEstimatedBalance();
  }, [coinsInfo, balance.balance_virtual,balance.balance_virtual ])
  useEffect(()=> {
    getEstimatedBalance();
    setCoinsInfo(props.coinsInfo);
    setBalance(props.balance)
  }, [props.coinsInfo,props.coins,props.balance])

  useEffect(()=> {
    getMarketPrice();
  }, [ props.prices, prevCalculation])



  const getEstimatedBalance = () => {
    let result = 0;
    if (coinsInfo && coinsInfo.length > 0){
      coinsInfo.forEach((element) => {
        result = result + Number(element.balance_usd)
      })
    }
    return result + Number(balance.balance_virtual)
  }

  const getMarketPrice = (symbol) => {
    let prices;
    let last_price;
    let color;

    if(symbol){
      if(symbol === 'usdt'){
        prices = 1
        color = '#000000';
      } else {
        prices = props.prices[symbol?.toUpperCase()]?.ask
        last_price = prevCalculation && prevCalculation[symbol?.toUpperCase()]?.ask
        color = last_price > prices ? '#FA1910' : last_price === prices ? '#000000' : '#6FCBA2'
      }
    }
    return {prices, last_price, color}
  }

  return(
    <>
      <Row style={{display: 'flex', alignItems: 'center', padding:'15px'}}>
        <Col xl={6}>
          <div>
            <span style={{color: '#1F45FF'}} className="font-size-14 font-regular">{props.traductions.wallets.Index.data_aproxBalance}</span>
          </div>
          <span className="font-size-40">{FormatMoney(getEstimatedBalance())}</span>
        </Col>
        <Col xl={6} style={{paddingTop: '25px'}}>
          <Row>
            <Col xl={6}>
              <div style={{display: 'flex'}}>
                <Image src={UsdIcon} width={35} style={{width:25, marginRight: '10px'}}/>
                <div className="font-size-12" style={{color: '#797878'}}>
                  Virtual USD
                  <div className="font-size-14 font-medium" style={{color: '#000'}}>{FormatMoney(balance.balance_virtual)}</div>
                </div>
              </div>
            </Col>
            <Col xl={6}>
              <div style={{display: 'flex'}}>
                <Image src={MxnIcon} width={35} style={{width:25, marginRight: '10px'}}/>
                <div className="font-size-14 font-medium">
                  <div className="font-size-12" style={{color: '#797878'}}>
                    Virtual MXN
                    <div className="font-size-14 font-medium" style={{color: '#000'}}>{FormatMoney(balance.balance_virtual_mxn)}</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Table className="table table-borderless" style={{marginTop: '30px'}} bordered={ false } borderless={false} responsive="md">
        <thead>
          <tr>
            <th>{props.traductions.VEX.t_h_instrument}</th>
            <th>{props.traductions.VEX.balance}</th>
            <th>{props.traductions.VEX.market_price} USD</th>
          </tr>
        </thead>
        <tbody>
          {
            coinsInfo.length > 0 && coinsInfo.map((inf, index) => {
              if (inf.coin !== 'dash'){
                return(
                  <tr id={index + 1}>
                    <td>
                      <div style={{display: 'flex'}}>
                        <Image style={{marginLeft:10, marginRight: '10px', width:25}} src={require('../../../CryptoIcons/' + inf?.coin + '.svg')}/>
                        <div>
                          <div className="font-size-14" style={{color: '#2e2c2c'}}>
                            {ListCoins[inf.coin]}
                          </div>
                          <div style={{color: '#3A72DB', fontSize: '12px'}}>{inf.wallets} {props.traductions.VEX.wallet} / {inf.addresses} {props.traductions.VEX.addresses}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div style={{color: '#2E2C2C'}} className="font-size-14">
                        {inf.balance}
                      </div>
                      <div style={{color: '#797878'}} className="font-size-12">
                        {FormatMoney(inf.balance_usd)}
                      </div>
                    </td>
                    <td>
                      <div style={{color: getMarketPrice(inf.coin).color}}>
                        { inf.coin === 'xrp' ? XrpFormatMoney(getMarketPrice(inf.coin).prices) 
                            : 
                          inf.coin === 'btc' || inf.coin === 'eth' || inf.coin === 'sol' ? FormatTwoDecimals(getMarketPrice(inf.coin).prices)
                            :
                          inf.coin === 'ltc' || inf.coin === 'bch' ? FormatThreeDecimals(getMarketPrice(inf.coin).prices)
                            :
                          FormatMoney(getMarketPrice(inf.coin).prices)
                        }
                      </div>
                    </td>
                  </tr>
                )
              }
            })
          }
        </tbody>
      </Table>
    </>
  )
}
export default WalletIndex
